
import Vue from "vue";
import RGBItem from "./RGBItem.vue";
import { rgbToHsv } from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/helpers";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    RGBItem
  }
})
export default class RGB extends Vue {
  @Prop()
  red!: number;

  @Prop()
  green!: number;

  @Prop()
  blue!: number;

  @Prop()
  alpha!: number;

  @Prop()
  updateColor!: Function;

  changeValue(field: string, value: number) {
    if (field === "alpha") {
      this.updateColor({ alpha: value / 100 });
      return;
    }

    const color = rgbToHsv({
      red: this.red,
      green: this.green,
      blue: this.blue,
      [field]: value
    });

    this.updateColor({ ...color, [field]: value });
  }
}
